export default function confirmPopup(message) {
	return (dispatch) => {
		dispatch({
			type: 'ERROR_POPUP',
			payload: {message},
		});
	};
}